<template>
    <div>
        <nav class="header-navbar navbar navbar-expand-lg align-items-center floating-nav navbar-light navbar-shadow">
            <div class="navbar-container d-flex content"
                 style="background-color: #316992 !important;    box-shadow: 0 0 10px 1px rgb(142 150 153);">
                <div class="bookmark-wrapper d-flex align-items-center">
                    <ul class="nav navbar-nav d-xl-none">
                        <li class="nav-item"><a class="nav-link menu-toggle" href="javascript:void(0);"><i class="ficon text-white" data-feather="menu"></i></a>
                        </li>
                    </ul>
                </div>
                <ul class="nav navbar-nav align-items-center ml-auto">
                    <li class="nav-item dropdown dropdown-user" >
                        <a
                            class="nav-link dropdown-toggle dropdown-user-link"
                            id="dropdown-user"
                            href="javascript:void(0);"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            <div class="user-nav d-sm-flex d-none">
                <span class="user-name font-weight-bolder text-white">{{name}}</span
                ><span class="user-status text-white">Active</span>
                            </div>
                            <span class="avatar"
                            ><img
                                class="round"
                                :src="
                    `${publicPath}app-assets/images/portrait/small/avatar-2.jpg`
                  "
                                alt="avatar"
                                height="40"
                                width="40"/><span class="avatar-status-online"></span
                            ></span>
                        </a>
                        <div
                            class="dropdown-menu dropdown-menu-right"
                            aria-labelledby="dropdown-user"
                            style="width: auto !important;"
                        >
                          <a class="dropdown-item" href="javascript:void(0)" @click="showChangePassModal = true"
                          ><i class="mr-50" data-feather="lock"></i> Change Password</a
                          >
                          <a class="dropdown-item" href="javascript:void(0)" @click="logout"
                        ><i class="mr-50" data-feather="power"></i> Logout</a
                        >


                        </div>
                    </li>
                </ul>
            </div>
        </nav>

        <ul class="main-search-list-defaultlist-other-list d-none">
            <li class="auto-suggestion justify-content-between">
                <a
                    class="d-flex align-items-center justify-content-between w-100 py-50"
                >
                    <div class="d-flex justify-content-start">
            <span class="mr-75" data-feather="alert-circle"></span
            ><span>No results found.</span>
                    </div>
                </a>
            </li>
        </ul>
      <ChangePasswordModal :show="showChangePassModal" @hide="showChangePassModal = false"></ChangePasswordModal>
    </div>
</template>

<script>
import ChangePasswordModal from "../common/modals/ChangePasswordModal";
export default {
    components:{
      ChangePasswordModal
    },
    mounted() {
      var loginData = this.$store.getters.getByKey(
          "login"
      );
      if(loginData){
        if(loginData.row){
          this.name = loginData.row.first_name+' '+loginData.row.last_name
        }
      }
    },
    data() {
        return {
          showChangePassModal:false,
          name:'Admin'
        };
    },
    methods: {
        logout() {
            this.makeRequest('post', 'v1/logout', {},{},false).then(callResponse => {

                if (!callResponse.error) {
                    let code = callResponse.response.data.code;

                    if (code == 200) {
                        localStorage.setItem('vault-pay-admin-access-token', null);
                        localStorage.clear();
                        this.removeCookie('PHPSESSID')
                        this.$router.push({name: 'login'})
                    }
                }

            });

        },
    }
};
</script>

